// @flow

import { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import * as R from 'ramda'
// import { replace, map, prop, split, head, gte, equals, is, or } from 'ramda'

import { getHttpForSourceLinkEnabled } from '@alphaott/app-main/selectors'
import { getOsVersion } from '@alphaott/smart-tv-current-device/selectors'
import { getDeviceType, PLATFORMS } from '@alphaott/smart-tv-platforms'

const devicePlatform = getDeviceType()
// From this version and below - old devices
const OLD_OS_VERSION = 4

// For older devices
export const useHttpForSourceLink = () => {
  const isHttpForSourceLinkEnabled = useSelector(getHttpForSourceLinkEnabled)
  const osVersion = useSelector(getOsVersion)

  const isWebPlatform = R.equals(devicePlatform, PLATFORMS.WEB)
  const isOldDevice = useMemo(() => {
    if (isWebPlatform) return false

    const majorVersion = R.head(R.split('.', String(osVersion)))
    return R.gte(OLD_OS_VERSION, majorVersion)
  }, [isWebPlatform, osVersion])

  const handleReplaceScheme = useCallback((src) => R.replace('https://', 'http://', src), [])

  const handlePrepareSource = useCallback(
    (source) => {
      if (!source) {
        return null
      }

      return {
        ...source,
        src: handleReplaceScheme(source.src),
      }
    },
    [handleReplaceScheme],
  )

  const handlePrepareSources = useCallback(
    (sources) =>
      R.is(Array, sources) &&
      R.map(
        (item) => ({
          ...item,
          src: handleReplaceScheme(R.prop('src', item)),
        }),
        R.or(sources, []),
      ),
    [handleReplaceScheme],
  )

  return {
    isRequiredHttpScheme: isHttpForSourceLinkEnabled && isOldDevice,
    onPrepareSource: handlePrepareSource,
    onPrepareSources: handlePrepareSources,
  }
}

export default useHttpForSourceLink
